<mat-card>
  <app-card-header
    title="Configuración"
    subtitle="Preferencias de esta sesión"
    icono="settings"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-content-card title="Apariencia" icon="palette">
      <div class="ajuste">
        <mat-icon class="ajuste-icono">
          {{ helper.darkTheme ? 'dark_mode' : 'light_mode' }}
        </mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Modo oscuro</span>
          <small class="ayuda">Cambia entre tema claro y oscuro</small>
        </div>
        <mat-slide-toggle
          [checked]="helper.darkTheme"
          (change)="toggleTheme()"
          color="primary"
        ></mat-slide-toggle>
      </div>
      <div class="ajuste">
        <mat-icon class="ajuste-icono">celebration</mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Efectos Festivos</span>
          <small class="ayuda">
            Activa o desactiva efectos especiales de temporada
          </small>
        </div>
        <mat-slide-toggle
          [checked]="efectosFestivosActivos"
          (change)="toggleEfectosFestivos()"
          color="primary"
        ></mat-slide-toggle>
      </div>
    </app-content-card>

    <app-content-card title="Mapas" icon="map">
      <div class="ajuste">
        <mat-icon class="ajuste-icono">location_city</mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Edificios 3D en Mapas</span>
          <small class="ayuda">
            Muestra edificios y elementos 3D en los mapas
          </small>
        </div>
        <mat-slide-toggle
          [checked]="mapa3DEnabled"
          (change)="toggleMapa3D()"
          color="primary"
        ></mat-slide-toggle>
      </div>
      <div class="ajuste">
        <mat-icon class="ajuste-icono">wb_twilight</mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Ciclo Día/Noche en Mapas</span>
          <small class="ayuda">
            Ajusta la iluminación del mapa según la hora del día
          </small>
        </div>
        <mat-slide-toggle
          [checked]="mapaDiaNocheEnabled"
          (change)="toggleMapaDiaNoche()"
          color="primary"
        ></mat-slide-toggle>
      </div>
      <div class="ajuste">
        <mat-icon class="ajuste-icono">contrast</mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Mapa Minimal en Modo Oscuro</span>
          <small class="ayuda">
            Usa estilo oscuro para el mapa minimal (tercera opción)
          </small>
        </div>
        <mat-slide-toggle
          [checked]="mapaOscuroEnabled"
          (change)="toggleMapaOscuro()"
          color="primary"
        ></mat-slide-toggle>
      </div>
      <div class="ajuste">
        <mat-icon class="ajuste-icono">place</mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Puntos de Interés (POIs)</span>
          <small class="ayuda">
            Muestra etiquetas de lugares, comercios y puntos de interés
          </small>
        </div>
        <mat-slide-toggle
          [checked]="mapaPOIsEnabled"
          (change)="toggleMapaPOIs()"
          color="primary"
        ></mat-slide-toggle>
      </div>
    </app-content-card>

    <app-content-card title="Sonido" icon="volume_up">
      <div class="ajuste">
        <mat-icon class="ajuste-icono">
          {{ sonidoMuteado ? 'volume_off' : 'volume_up' }}
        </mat-icon>
        <div class="ajuste-texto">
          <span class="ajuste-titulo">Silenciar sonidos</span>
          <small class="ayuda">
            Desactiva todas las alertas sonoras de la aplicación
          </small>
        </div>
        <mat-slide-toggle
          [checked]="sonidoMuteado"
          (change)="toggleSonido()"
          color="primary"
        ></mat-slide-toggle>
      </div>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="principal" type="button" (click)="dialogRef.close()">
      Listo
    </button>
  </mat-card-actions>
</mat-card>
